import { draft } from '$utils/services/formDraftService'
import { broadcastFormDraftName, broadcastFormSteps } from '$views/RecommendationsForms/BroadcastForm/BroadcastForm'
import { BroadcastService } from '$domain/model/recommendation/recommendation.model'
import { newBroadcastService } from '$domain/model/recommendation/recommendation.manager'
import { tagManager } from '$infrastructure/tagManager/tagManager'

export const createNewBroadcastService = () => {
  const broadcastForm = draft.get(broadcastFormDraftName)
  const service: BroadcastService = {
    address: broadcastForm[broadcastFormSteps.serviceInformationStep.location]
      ? broadcastForm[broadcastFormSteps.serviceInformationStep.location].address
      : '',
    province: broadcastForm[broadcastFormSteps.serviceInformationStep.location]
      ? broadcastForm[broadcastFormSteps.serviceInformationStep.location].province
      : '',
    latitude: broadcastForm[broadcastFormSteps.serviceInformationStep.location]
      ? broadcastForm[broadcastFormSteps.serviceInformationStep.location].latitude
      : 0,
    longitude: broadcastForm[broadcastFormSteps.serviceInformationStep.location]
      ? broadcastForm[broadcastFormSteps.serviceInformationStep.location].longitude
      : 0,
    information: broadcastForm[broadcastFormSteps.serviceInformationStep.careInformation]
      ? broadcastForm[broadcastFormSteps.serviceInformationStep.careInformation]
      : '',
    phoneNumber: broadcastForm[broadcastFormSteps.serviceInformationStep.phoneNumber]
      ? broadcastForm[broadcastFormSteps.serviceInformationStep.phoneNumber]
      : '',
    careType: broadcastForm[broadcastFormSteps.serviceInformationStep.careType]
      ? broadcastForm[broadcastFormSteps.serviceInformationStep.careType]
      : '',
    hoursPerWeek: broadcastForm[broadcastFormSteps.serviceInformationStep.hoursPerWeek]
      ? broadcastForm[broadcastFormSteps.serviceInformationStep.hoursPerWeek]
      : '',
    name: broadcastForm[broadcastFormSteps.contactStep] ? broadcastForm[broadcastFormSteps.contactStep].name : '',
    email: broadcastForm[broadcastFormSteps.contactStep] ? broadcastForm[broadcastFormSteps.contactStep].email : '',
  }

  tagManager.push({
    event: 'publishoffer',
    offerType: 'broadcast',
  })

  const broadcastResponse = newBroadcastService(service)

  draft.unsetAll()

  return broadcastResponse
}



// WEBPACK FOOTER //
// ./src/services/customer/broadcastService/broadcastService.service.ts